<template>
  <div class="card mb-0 shadow">
    <div class="card-body">
      <div class="tab-content">
        <div class="animate__animated animate__fadeIn">
          <div class="row">
            <div class="col-12">
              <h4 class="font-weight-bold">Histórico de Notificações</h4>
            </div>
            <div class="col-12">
              <load v-if="loading" mode="table" />
              <div v-else class="col-12">
                <b-table
                  :fields="[
                    {
                      key: 'vvd',
                      label: $t('Detalhes'),
                    },
                    {
                      key: 'data',
                      label: $t('Data'),
                    },
                    {
                      key: 'status',
                      label: $t('Status'),
                    },
                    {
                      key: 'actions',
                      label: '',
                      class: 'text-right',
                      thStyle: {
                        width: '95px',
                        minWidth: '95px',
                      },
                    },
                  ]"
                  :items="notifificacoes"
                  :responsive="true"
                  hover
                  outlined
                  show-empty
                  small
                  stacked="md"
                  striped
                  table-class="mb-3"
                >
                  <template v-slot:cell(vvd)="data">
                    Usuário(s):<br />
                    <ul>
                      <li
                        v-for="pessoa in data.item.vvd.pessoas_objetos"
                        :key="pessoa.id"
                      >
                        <b>{{ pessoa.nome_completo }}</b>
                      </li>
                    </ul>
                    Violações:
                    <b>
                      <a
                        v-if="
                          data.item.vvd.violacoes_nomes &&
                          data.item.vvd.violacoes_nomes.length > 0
                        "
                        href="#"
                        @click.prevent="
                          getViolacoes(data.item.vvd.violacoes_nomes, data.item.vvd)
                        "
                      >
                        Ver Situações ({{ data.item.vvd.violacoes_nomes.length }})</a
                      >
                    </b>
                  </template>
                  <template v-slot:cell(data)="data">
                    Data do registro:<br />
                    {{ data.item.vvd.cadastrado }}
                    Notificação realizada:<br />
                    {{ data.item.data }}
                  </template>
                  <template v-slot:cell(status)="data">
                    <span class="small" v-html="data.item.vvd.status_nome"></span>
                  </template>
                  <template v-slot:cell()="data">
                    <b-button
                      v-b-tooltip.hover
                      :title="$t('Detalhes da Notificação')"
                      class="px-2 mb-0"
                      size="xs"
                      type="button"
                      variant="primary"
                      @click.prevent="$bvModal.show('modalVerNotificacao' + data.item.id)"
                    >
                      <i class="mdi mdi-eye" />
                    </b-button>

                    <b-modal
                      hide-footer
                      :id="'modalVerNotificacao' + data.item.id"
                      title="Detalhes da Notificação"
                      centered
                    >
                      <table class="table table-bordered table-sm table-striped">
                        <tr>
                          <td>Técnico da notificação: <br />{{ data.item.user.name }}</td>
                          <td>Data: <br />{{ data.item.data }}</td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            Unidades notificadas:
                            <ol>
                              <li v-for="item in data.item.unidades" :key="item.id">
                                {{ item.nome }}
                              </li>
                            </ol>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <h4>Situações relatada na notificação:</h4>
                            <span>{{ data.item.situacao }}</span>
                          </td>
                        </tr>
                      </table>
                    </b-modal>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center my-5">
                      <img
                        :alt="$t('No results')"
                        class="mb-5"
                        src="/img/icons/robot.svg"
                        style="max-height: 165px"
                      />
                      <h3 class="bold">
                        {{ $t("No records found") }}
                      </h3>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalVerViolacoes :dados="vddSelecionada" :itens="violacoes" />
  </div>
</template>
<script>
import ModalVerViolacoes from "../../includes/ModalVerViolacoes";

export default {
  props: ["violacaodedireito"],
  components: { ModalVerViolacoes },
  metaInfo() {
    return {
      title: this.$i18n.t("Histórico de Notificações de Violação de Direitos"),
    };
  },
  data() {
    return {
      loading: true,
      notifificacoes: [],
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      violacoes: [],
      vddSelecionada: {},
    };
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    getViolacoes(value, vddSelecionada) {
      this.violacoes = value;
      this.vddSelecionada = vddSelecionada;
      this.$bvModal.show("modalVerViolacoes");
    },
    getNotifications() {
      this.loading = true;

      axios
        .get("api/dashboard/vvd/listar/notificacoes", {
          params: {
            vvd_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.notifificacoes = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getNotifications();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getNotifications();
      }
    },
  },
};
</script>
